import { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import set from "lodash/set";
import Input from "@components/ui/Input";
import Textarea from "@components/ui/TextArea";
import { mergeDefaultConfig } from "@features/schema-management/actions";
import IconRefresh from "@assets/icons/IconRefresh";
import { dispatchObjErrors } from "@features/schema-management/interfaces/sypiBrcInterface";
import cloneDeep from "lodash/cloneDeep";

const CustomStringTemplate = (props) => {
  const dispatch = useDispatch();
  const sypiNewView = useSelector((state) => state.sypiNewView);
  const sypiSchema = useSelector((state) => state.sypiSchema);
  const schemaAllView = useSelector((state) => state.schemaAllView);
  const smSchema = useSelector((state) => state.schema);
  const isSypi = !!sypiNewView;

  const { defaultConfig } = isSypi ? sypiNewView : schemaAllView;
  const config = isSypi
    ? sypiNewView.sypiConfig
    : schemaAllView.schemaManagementConfig;
  const { clientSchema } = isSypi ? sypiSchema : smSchema;
  const {
    id,
    value,
    required,
    onBlur,
    onFocus,
    onChange: inputChange,
    schema,
  } = props;
  const path = id
    .split(isSypi ? "_" : ".")
    .slice(1)
    .join(".");
  const defaultVal = get(defaultConfig, path) || schema?.default;
  const returnNewConfig = (newVal) =>
    config ? set(cloneDeep(config), path, newVal) : cloneDeep(config);
  const [expanded, setExpanded] = useState(false);
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const expansionThreshold = 40;

  useEffect(() => {
    if (!value) setExpanded(false);
    setShouldDisplay(defaultVal !== value);
  }, [value, defaultVal]);

  return (
    <Fragment>
      <div key={`${id}-container`} className={`icon-refresh-input-container`}>
        {shouldDisplay && (
          <IconRefresh
            onClick={(event) => {
              let newConfig = returnNewConfig(defaultVal);
              inputChange(defaultVal);
              dispatch(mergeDefaultConfig(newConfig));
              dispatchObjErrors(newConfig, clientSchema);
            }}
          />
        )}
      </div>
      {expanded ? (
        <Textarea
          externalContainer
          className={"form-control"}
          inputName={id}
          inputValue={value}
          onChangeCallback={(e) => inputChange(e?.target.value)}
          onBlurCallback={(e) => onBlur(id, e?.target.value)}
          onFocusCallback={(e) => onFocus(id, e?.target.value)}
          textAreaContainerStyle="col-start-[1] col-end-[4]"
        />
      ) : (
        <Input
          externalContainer
          className={"form-control"}
          inputName={id}
          inputValue={value}
          onChangeCallback={(e) => inputChange(e?.target.value)}
          onBlurCallback={(e) => onBlur(id, e?.target.value)}
          onFocusCallback={(e) => onFocus(id, e?.target.value)}
          inputContainerStyle="col-start-[1] col-end-[4]"
          required={false}
        />
      )}
      {value && (value.length > expansionThreshold || expanded) && (
        <div
          className="btn-text-expand"
          onClick={(e) => setExpanded((value) => !value)}
        >
          {expanded ? "-" : "+"}
        </div>
      )}
    </Fragment>
  );
};

export default CustomStringTemplate;
